module.exports = __webpack_public_path__ + "img/bandeira-espanha.f161d80f.svg";